import {
  queryConfig,
  queryField,
  save,
  saveProcess,
  get,
} from '@/services/down/ignoreUpdate';

export default {
  namespace: 'ignoreUpdate',
  state: {},

  effects: {
    *queryConfig({ payload, callback }, { call, put }) {
      const response = yield call(queryConfig, payload);
      if (callback) callback(response);
    },
    *queryField({ payload, callback }, { call, put }) {
      const response = yield call(queryField, payload);
      if (callback) callback(response);
    },
    *save({ payload, callback }, { call, put }) {
      const response = yield call(save, payload);
      if (callback) callback(response);
    },
    *saveProcess({ payload, callback }, { call, put }) {
      const response = yield call(saveProcess, payload);
      if (callback) callback(response);
    },
    *get({ payload, callback }, { call, put }) {
      const response = yield call(get, payload);
      if (callback) callback(response);
    },
  },

  reducers: {
    success(state, action) {
      return {
        ...state,
        data: action.payload,
      };
    },
  },
};
